import {http} from '../http'
import * as featureSettingsApi from '../../coreApi/feature-settings'

import {APIResponse} from '../types'
import {Client} from '../../../types'
import {handleError} from '../handleError'

interface Params {
  clientID: Client['ID']
  featureID: number
}

export interface PersonTargetFeatureRow {
  id: number
  clientID: number
  // PersonID of the original granter as stored on the row. Must be echoed
  // back verbatim on DELETE — the server matches it in SQL. See
  // coreApi/feature-settings/deletePersonTargetFeature.ts for the auth model.
  granterPersonID: number
  targetPersonID: number
  featureID: number
  startDate: string | null
  endDate: string | null
}

type ListPersonTargetFeaturesReturn = APIResponse<PersonTargetFeatureRow[]>

export interface ListPersonTargetFeatures {
  (params: Params): Promise<ListPersonTargetFeaturesReturn>
}

const ERROR_PATH = 'api.featuresettings.listPersonTargetFeatures()'
const GENERIC_ERROR =
  'Something went wrong while loading feature access. Please try again.'
// Cold-start: each camp opts staff in one-by-one, so realistic page sizes are
// small. 1000 leaves headroom while still being a single request.
const PERSON_TARGET_FEATURES_PAGE_SIZE = 1000

export const listPersonTargetFeatures: ListPersonTargetFeatures = async ({
  clientID,
  featureID,
}) => {
  try {
    const response = await featureSettingsApi.listPersonTargetFeatures(http, {
      ClientID: Number(clientID),
      FeatureID: featureID,
      PageNumber: 1,
      PageSize: PERSON_TARGET_FEATURES_PAGE_SIZE,
    })

    return {
      result: 'success',
      data: response.data.Results.map((raw) => ({
        id: raw.ID,
        clientID: raw.ClientID,
        granterPersonID: raw.PersonID,
        targetPersonID: raw.TargetPersonID,
        featureID: raw.FeatureID,
        startDate: raw.StartDate,
        endDate: raw.EndDate,
      })),
    }
  } catch (e) {
    return handleError(ERROR_PATH, GENERIC_ERROR, e)
  }
}
